import { apiClient } from './apiService';
import {
  BRANCH_RECEIVABLES,
  RECEIVABLE_DETAIL,
  RECEIVABLE_VOID
} from './endpoints';
import {
  CustomerReceivableDetail,
  ReceivableListParams,
  ReceivableListResponse,
  ReceivableVoidResult
} from '@/types/CustomerReceivable.interface';

export const receivableService = {
  async list(
    branchId: number,
    params: ReceivableListParams = {}
  ): Promise<ReceivableListResponse> {
    const response = await apiClient.get<ReceivableListResponse>(
      BRANCH_RECEIVABLES.replace(':branchId', String(branchId)),
      params
    );
    return response.data;
  },

  async getById(id: number): Promise<CustomerReceivableDetail> {
    const response = await apiClient.get<CustomerReceivableDetail>(
      RECEIVABLE_DETAIL.replace(':id', String(id))
    );
    return response.data;
  },

  /** Cancels a receivable that has no collections (400 otherwise). */
  async voidReceivable(
    id: number,
    reason?: string
  ): Promise<ReceivableVoidResult> {
    const response = await apiClient.post<ReceivableVoidResult>(
      RECEIVABLE_VOID.replace(':id', String(id)),
      reason ? { reason } : {}
    );
    return response.data;
  }
};
